:host {
  display: block;
}

input {
  @include form-input;
}

select {
  @include form-select;
}

.form-field {
  @include form-field;
  margin-bottom: 8px;
  direction: var(--av-direction);
}

label {
  @include form-label;
}

.form-field-phone {
  display: flex;
  flex-direction: row;
  margin-top: 12px;
  input {
    padding-right: 4px;
    padding-left: 4px;
  }
}

.error-text-phone {
  height: calc(100% - 18px) !important;
}

.av-direction {
  direction: var(--av-direction);
}

.form-field-not-supported {
  background-color: var(--av-color-warning);
  color: var(--av-color-warning-contrast);
  padding: 8px;
  border-radius: var(--av-border-radius-container);
}
